// SearchFlix.js
import { connect } from 'react-redux';

import fetchMessageSearch from '../action/fetchMessageSearch.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import SearchFlix from '../component/SearchFlix.jsx';
import withSearchQuery from '../component/WithSearchQuery.jsx';

const mapStateToProps = (state, { query }) => {
  const { sorts: sortings } = getSelectedQueryOptionObject(
    state,
    '',
    getSelectedFeedQueryOptions(state, 'SEARCH_MESSAGE', undefined)
  );
  const sortingString = sortings.join('&');

  const hasQuery = !!query;
  const defaultFlixCategory = getOperationData(
    state,
    ['recommendFlixCategory'],
    'search'
  );

  const flixSelectPath = ['search', 'message', 'flix', query];
  const defaultFlixSelectPath = ['home', 'messages', defaultFlixCategory];

  const isAuthed = !!getMeData(state, 'id');

  const searchFlixIds = getListData(state, flixSelectPath, 'itemIds');
  const defaultFlixIds = getListData(state, defaultFlixSelectPath, 'itemIds');

  const isSearchFlixFetched = getNetworkingData(
    state,
    [...flixSelectPath, 'firstPage'],
    'isFetched'
  );
  const isDefaultFlixFetched = getNetworkingData(
    state,
    [...defaultFlixSelectPath, 1],
    'isFetched'
  );

  return {
    sortingString,
    query,
    defaultFlixCategory,
    isAuthed,
    isFlixFetched: hasQuery ? isSearchFlixFetched : isDefaultFlixFetched,
    hasQuery,
    flixIds: hasQuery ? searchFlixIds : defaultFlixIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    fetchMessageSearch: data => dispatch(fetchMessageSearch(data)),
  };
};

export default withSearchQuery(
  connect(mapStateToProps, mapDispatchToProps)(SearchFlix)
);
